import { useGetMyWorkOrdersQuery, WorkOrderStatus } from '@/generated/codegen';
import { useCan } from '@/hooks/useRbac';

/**
 * Single source of truth for the maquinista's in-progress work orders.
 * Shared by the footer badge and the guided tour: every consumer reads the
 * same Apollo cache entry with the same 30s poll, so concurrent ticks are
 * deduped on the wire instead of each component owning its own query config.
 */
export const useInProgressWorkOrders = () => {
  const can = useCan();
  const { data } = useGetMyWorkOrdersQuery({
    variables: {
      filter: {
        status: [WorkOrderStatus.InProgress],
      },
    },
    pollInterval: 30000,
    notifyOnNetworkStatusChange: true,
    skip: !can('work-order:view-assigned'),
  });
  const count =
    (data &&
      'getMyAssignedWorkOrders' in data &&
      data.getMyAssignedWorkOrders.items.length) ||
    0;
  return { count };
};
